export default "__VITE_ASSET__CepXVOQc__"